var Layout;
(function (Layout) {
  Layout["VERTICAL"] = "VERTICAL";
  Layout["VERTICAL_TWO_COLUMN"] = "VERTICAL_TWO_COLUMN";
  Layout["VERTICAL_ONE_COLUMN"] = "VERTICAL_ONE_COLUMN";
  Layout["HORIZONTAL"] = "HORIZONTAL";
  Layout["HORIZONTAL_JUSTIFIED"] = "HORIZONTAL_JUSTIFIED";
  Layout["HORIZONTAL_LEFT_ALIGNED"] = "HORIZONTAL_LEFT_ALIGNED";
  Layout["HORIZONTAL_RIGHT_ALIGNED"] = "HORIZONTAL_RIGHT_ALIGNED";
})(Layout || (Layout = {}));

export { Layout };
//# sourceMappingURL=layouts.mjs.map
